import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import ins from './modules/ins'
import loading from './modules/loading'
import user from './modules/user'
import rsa from './modules/rsa'
import types from './mutation-types'
import api from '@/api'
import { WITH_LOADING } from '@/store/action-types'
const TIME_RANGE = 1800
const REMIND_TIME_RANGE = 600

Vue.use(Vuex)

const onDevMode = process.env.NODE_ENV !== 'production'
const state = function () {
  return {
    settingTimer: 0,
    timer: TIME_RANGE,
    remindTimer: REMIND_TIME_RANGE,
    preTime: null,
    admUsers: {}
  }
}
const getters = {
  admUserInfo: state => {
    return state.admUsers
  },
  remindTimer: state => {
    return state.remindTimer
  }
}
const mutations = {
  [types.ADM_USER_INFO]: (state, admUsers) => {
    state.admUsers = admUsers
  },
  [types.SETTING_TIMER] (state, timer) {
    if (timer.timeout) {
      state.settingTimer = timer.timeout
      state.timer = state.settingTimer
    }
    if (timer.remindTimeout) {
      state.remindTimer = timer.remindTimeout
    }
  },
  [types.RESET_TIMER]: (state, getSetting) => {
    if (state.settingTimer > 0) {
      state.timer = state.settingTimer
    } else {
      state.timer = TIME_RANGE
    }
    state.preTime = new Date()
  },
  [types.DECREMENT_TIMER]: (state) => {
    if (state.preTime === null) {
      state.preTime = new Date()
    }
    let nowTime = new Date()
    let diffSecs = Math.floor((nowTime.getTime() - state.preTime.getTime()) / 1000)
    // state.timer--
    if (diffSecs >= 1) {
      state.timer -= diffSecs
      state.preTime = nowTime
    }
    if (state.timer < 0) {
      state.timer = 0
    }
  }
}
const actions = {
  featchSettingTimer: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/adm/com/timerrange', { params }).then(r => {
      commit(types.SETTING_TIMER, r.data)
      return r
    })
    return dispatch(WITH_LOADING, { action }, { root: true })
  }
}

export default new Vuex.Store({
  strict: onDevMode,
  state,
  getters,
  mutations,
  actions,
  modules: {
    common,
    ins,
    loading,
    user,
    rsa
  }
})
